/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";
import { useEffect } from "react";
import Button from "uis/Button";
import VisitInfoTalkImg from "../../../../assets/imgs/visitors-onboard/visit-info-talk.png";
import VisitInfoEmailImg from "../../../../assets/imgs/visitors-onboard/visit-info-email.png";
import { SendingVisitInfoProcess } from "./process/sendingVisitInfoProcess";
import { useRecoilValue } from "recoil";
import { member, workspace } from "recoil/recoilState";
import { encrypt } from "utils/crypto";
import { gaEvent } from "utils/ga-utils";

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
`;

const Process = styled.div`
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${theme.neutral50};
`;

const ImageContent = styled.div`
  height: 45%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;

  height: 20%;
  background-color: ${theme.neutral50};
`;
const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: ${theme.neutral900};

  display: flex;
  justify-content: center;
  align-items: center;
`;
const SubText = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${theme.neutral600};

  display: flex;
  flex-direction: row;
  gap: 2px;
`;

const Footer = styled.div`
  height: 15%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  box-sizing: border-box;
  padding: 0px 50px;
  width: 100%;
  background-color: ${theme.neutral50};
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;
const SkipButton = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${theme.neutral400};
  text-decoration: underline;

  cursor: pointer;
`;

type Props = {
  isFirst: boolean;
  onClickNext: () => void;
  onClickBack: () => void;
  onClickSkip: () => void;
};

export default function SendingVisitInfoPage(props: Props) {
  const { isFirst, onClickNext, onClickBack, onClickSkip } = props;
  const workspaceInfo = useRecoilValue(workspace);
  const memberInfo = useRecoilValue(member);

  const onClickPreview = () => {
    if (workspaceInfo?.id) {
      window.open(`${process.env.REACT_APP_VISITORS_WEB_URL}/default/${encodeURIComponent(encrypt(workspaceInfo.id))}`);
    }
    gaEvent("온보딩 - 기업 방문 메세지 프리뷰 선택");
  };

  useEffect(() => {
    if (isFirst) {
      gaEvent("첫 온보딩 - 방문자 안내하기");
    } else {
      gaEvent("온보딩 - 방문자 안내하기");
    }
  }, []);

  return (
    <RootContainer>
      <Process>
        <SendingVisitInfoProcess></SendingVisitInfoProcess>
      </Process>
      <ImageContent>
        <img width="240" src={VisitInfoTalkImg} alt="VisitInfoTalkImg"></img>
        <img width="460" src={VisitInfoEmailImg} alt="VisitInfoEmailImg"></img>
      </ImageContent>
      <InfoContent>
        <Title>방문이 등록되면 방문자에게 기업 방문 안내 메세지가 전송됩니다!</Title>
        <SubText>
          우리 회사의 방문 안내 메세지를 확인해보세요!&nbsp;
          <div
            onClick={onClickPreview}
            css={css`
              text-decoration: underline;
              cursor: pointer;
              color: ${theme.primary500};
            `}
          >
            {workspaceInfo?.name}의 상세 방문 안내 메세지 확인하기
          </div>
        </SubText>
      </InfoContent>
      <Footer>
        <SkipButton onClick={onClickSkip}>건너뛰기</SkipButton>
        <ButtonContainer>
          <Button
            title="이전"
            type="secondary"
            styles={{
              container: css`
                width: 120px;
                height: 63px;
              `,
              text: css`
                font-size: 18px;
              `,
            }}
            onClick={onClickBack}
          />
          <Button
            title="다음"
            type="primary"
            styles={{
              container: css`
                width: 260px;
                height: 63px;
              `,
              text: css`
                font-size: 18px;
              `,
            }}
            onClick={onClickNext}
          />
        </ButtonContainer>
      </Footer>
    </RootContainer>
  );
}
